import { Fragment } from 'react/jsx-runtime';
import { safeJson } from '@/scripts/utils';
import SysText from '../../sysText';

const GroupRemoveMemberMessage = memo(
  ({ payload, noStyle }: { payload: string; noStyle?: boolean }) => {
    const { user_name, member } = safeJson(payload, { user_name: '', member: [] });
    return (
      <SysText noStyle={noStyle}>
        <Trans
          components={{
            name: <a />,
            members: (
              <>
                {member?.map((item: any, index: number) => (
                  <Fragment key={index}>
                    {index > 0 && ', '}
                    <a>{item.user_name}</a>
                  </Fragment>
                ))}
              </>
            ),
          }}
          values={{
            name: user_name,
          }}
          i18nKey="messages.chat.message.group.groupRemoveMember"
        />
      </SysText>
    );
  }
);
export default GroupRemoveMemberMessage;
